import React from 'react';

interface DetailFieldProps {
  label: string;
  value: string | number;
  fullWidth?: boolean;
}

export const DetailField: React.FC<DetailFieldProps> = ({
  label,
  value,
  fullWidth,
}) => (
  <div
    style={{
      marginBottom: '16px',
      flex: fullWidth ? '1 1 100%' : '1 1 45%',
      minWidth: fullWidth ? '100%' : '200px',
    }}>
    <label
      style={{
        display: 'block',
        color: '#aaa',
        fontSize: '0.68rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '1px',
        marginBottom: '4px',
      }}>
      {label}
    </label>
    <div
      style={{
        color: '#fff',
        fontSize: '0.9rem',
        fontWeight: 500,
        wordBreak: 'break-word',
      }}>
      {value || '—'}
    </div>
  </div>
);
